
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/calendars/[slug]/[symbol]",
      function () {
        return require("private-next-pages/calendars/[slug]/[symbol].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/calendars/[slug]/[symbol]"])
      });
    }
  